'use strict';

window.addEventListener('DOMContentLoaded', () => {
  const galleryButton = document.querySelector(
    '.commonPageLightGalleryCta'
  ) as HTMLElement;
  const galleryItem = document.querySelectorAll(
    '.commonPageLightGalleryItem'
  ) as NodeListOf<HTMLElement>;
  // galleryItemの数を調べる
  const galleryItemLength = galleryItem?.length;
  // galleryItemの数が8以下の場合は、galleryButtonを非表示にする
  if (galleryItemLength <= 8) {
    // galleryButtonが存在する場合は非表示にする
    if (galleryButton) {
      galleryButton.style.display = 'none';
    }
  }
});
